"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Circle_1 = __importDefault(require("@mui/icons-material/Circle"));
const HourglassEmptyRounded_1 = __importDefault(require("@mui/icons-material/HourglassEmptyRounded"));
const RadioButtonUnchecked_1 = __importDefault(require("@mui/icons-material/RadioButtonUnchecked"));
const core_1 = require("companion-app-components/utils/core");
const utils_1 = require("data/accounts/utils");
const QHelp_1 = __importDefault(require("components/QHelp"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const compose_1 = __importDefault(require("utils/compose"));
const utils_2 = require("data/transactions/utils");
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const ReviewedField = ({ attributes, SHOW_ALL, txn, forceStatic, callbacks, isWindowsDataset, fieldActive, isTypeGrossPaycheck, showTooltip, updateShowTooltip, scriptId, field, isAccountNotSynced, editable, showQHelp, focusField, canReview = false, }) => {
    const { classes } = useStyles();
    const { userPreferences, setUserPreference } = (0, useQPreferences_1.default)();
    const renderBankPendingState = () => {
        const title = isWindowsDataset && userPreferences.windowsReviewedWarningEnabled ?
            'Click here to learn what this is and how to use it' : 'Pending Transaction';
        return (<QIconButton_1.default aria-label="Bank Pending Transaction" focusRipple IconComponent={HourglassEmptyRounded_1.default} IconProps={{ className: classes.bankPending }} size="small-target" tooltip={title}/>);
    };
    const renderReviewedState = () => {
        let title;
        if (isWindowsDataset) {
            if (userPreferences.windowsReviewedWarningEnabled) {
                title = 'Click here to learn what this is and how to use it';
            }
            else {
                title = txn.isReviewed
                    ? "Transaction 'Accepted' (Learn more in Transactions Settings -> Show/Hide Columns)"
                    : "Transaction 'Not Accepted', click to mark 'Accepted' (Learn more in Transactions Settings -> Show/Hide Columns)";
            }
        }
        else {
            title = txn.isReviewed
                ? "Transaction marked 'reviewed', click to mark 'not reviewed"
                : "Transaction marked 'Not reviewed', click to mark 'reviewed'";
        }
        return (<QIconButton_1.default aria-label="Set Reviewed State" ref={fieldActive ?
                (input) => {
                    focusField.current = input; // eslint-disable-line
                } : null} disabled={forceStatic || isTypeGrossPaycheck} autoFocus={fieldActive} focusRipple IconComponent={txn.isReviewed ? RadioButtonUnchecked_1.default : Circle_1.default} IconProps={{ className: (0, classnames_1.default)(classes.reviewed, txn.isReviewed ? 'reviewed' : 'not-reviewed') }} size="small-target" onMouseEnter={() => updateShowTooltip(true)} onMouseLeave={() => updateShowTooltip(false)} tooltip={title} TooltipProps={{
                open: showTooltip,
                position: 'left',
                disableInteractive: true,
                leaveDelay: 3,
            }}/>);
    };
    let ReviewedComponent;
    if ((0, utils_2.isBankOwnedPending)(txn)) {
        ReviewedComponent = (<styles_1.RegListItem {...attributes} tabIndex={null} className={(0, classnames_1.default)(classes.iconButtonColumn)}>
        {renderBankPendingState()}
      </styles_1.RegListItem>);
    }
    else if (!(0, utils_2.shouldShowReviewField)(txn.accountId) || (0, utils_2.isUnacceptedScheduledTxn)(txn)) {
        ReviewedComponent = (<styles_1.RegListItem {...attributes} tabIndex={null} className={(0, classnames_1.default)(classes.iconButtonColumn, forceStatic ? 'nopoint' : '')}>
      </styles_1.RegListItem>);
    }
    else {
        ReviewedComponent = (<styles_1.RegListItem {...attributes} id={`${scriptId}-${field}-${txn.isReviewed ? 'yes' : 'no'}_`} tabIndex={null} onClick={(0, utils_2.shouldDisableReviewField)(txn) || forceStatic || isTypeGrossPaycheck || (isAccountNotSynced && !editable) || !canReview ? null : () => {
                var _a;
                if (userPreferences.windowsReviewedWarningEnabled) {
                    setUserPreference({ windowsReviewedWarningEnabled: false });
                    return showQHelp('windowsReviewed');
                }
                if (!txn.isReviewed) {
                    core_1.tracker.track(core_1.tracker.events.txnReview, {
                        isC2REnabled: isWindowsDataset ? (0, utils_1.isC2REnabledAccount)(txn.accountId) : false,
                        action: 'markAsReviewed',
                        count: 1,
                    });
                }
                return (_a = callbacks.handleMenu) === null || _a === void 0 ? void 0 : _a.call(callbacks, 'reviewed', txn);
            }} className={(0, classnames_1.default)(classes.iconButtonColumn, forceStatic ? 'nopoint' : '')}>
        {SHOW_ALL && renderReviewedState()}
      </styles_1.RegListItem>);
    }
    return ReviewedComponent;
};
exports.default = (0, compose_1.default)((0, QHelp_1.default)())(ReviewedField);
